import { useGenerateAsyncQuizMe } from './useGenerateAsyncQuizMe';
import { useGenerateAsyncSummarization } from './useGenerateAsyncSummarization';
export const useInteractiveEducationProps = ({
  primaryContentId,
  contentType,
  lessonContentId,
  interactiveContentTrackingProps
}) => {
  const {
    onAsyncRegenerateQuiz,
    generateQuizError,
    generateQuizLoading
  } = useGenerateAsyncQuizMe({
    primaryContentId,
    contentType,
    lessonContentId,
    interactiveContentTrackingProps
  });
  const {
    summary,
    correlationId: summaryCorrelationId,
    summaryError,
    summaryLoading,
    refetchSummary,
    videoDuration
  } = useGenerateAsyncSummarization({
    primaryContentId,
    contentType,
    lessonContentId
  });
  return {
    handleTriggerAsyncQuizGeneration: onAsyncRegenerateQuiz,
    generateQuizError: !!generateQuizError,
    generateQuizLoading,
    summary,
    summaryCorrelationId,
    summaryError,
    summaryLoading,
    refetchSummary,
    videoDuration: videoDuration !== null && videoDuration !== void 0 ? videoDuration : undefined
  };
};